import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { waitUntil } from 'atc-js';

// import directly from getPixall.js so we dont need to mock all utils
import getPixall from './getPixall';
var isPageTagSent = false;
var removePageExitListener = function removePageExitListener() {};
function resetIsPageTagSent() {
  isPageTagSent = false;
}
export default function ensurePixallPageLoad(_x, _x2, _x3) {
  return _ensurePixallPageLoad.apply(this, arguments);
}
function _ensurePixallPageLoad() {
  _ensurePixallPageLoad = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(option, pixallData, _temp) {
    var _ref, _ref$history, history, _ref$isPageEvent, isPageEvent, pixall, _option, _option$skipPageEvent, skipPageEvent, _history$eventListene, _history$eventListene2, on, _history$eventListene3, off, _history$eventListene4, pageExitEvent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (option === void 0) {
            option = {};
          }
          _ref = _temp === void 0 ? {} : _temp, _ref$history = _ref.history, history = _ref$history === void 0 ? {} : _ref$history, _ref$isPageEvent = _ref.isPageEvent, isPageEvent = _ref$isPageEvent === void 0 ? false : _ref$isPageEvent;
          _context.next = 4;
          return getPixall(option);
        case 4:
          pixall = _context.sent;
          _option = option, _option$skipPageEvent = _option.skipPageEvent, skipPageEvent = _option$skipPageEvent === void 0 ? false : _option$skipPageEvent;
          try {
            if (isPageEvent) {
              removePageExitListener();
              isPageTagSent = true;

              // legacy support
              if (history.listen) {
                removePageExitListener = history.listen(resetIsPageTagSent);
              }

              // eventListener support
              if (history.eventListener) {
                _history$eventListene = history.eventListener, _history$eventListene2 = _history$eventListene.on, on = _history$eventListene2 === void 0 ? function () {} : _history$eventListene2, _history$eventListene3 = _history$eventListene.off, off = _history$eventListene3 === void 0 ? function () {} : _history$eventListene3, _history$eventListene4 = _history$eventListene.pageExitEvent, pageExitEvent = _history$eventListene4 === void 0 ? '' : _history$eventListene4;
                on(pageExitEvent, resetIsPageTagSent);
                removePageExitListener = function removePageExitListener() {
                  off(pageExitEvent, resetIsPageTagSent);
                };
              }
              pixall.push(pixallData);
            } else {
              waitUntil(function () {
                return isPageTagSent || skipPageEvent;
              }, function () {
                pixall.push(pixallData);
              }, 30, 15000);
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Pixall: Failed to Send Event: ', error);
          }
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ensurePixallPageLoad.apply(this, arguments);
}